<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Update Configuration Over The air (AT+GTUPC)</span>
        </div>
      </div>
    </p-header>
  
    <div class="row align-items-center">
  
      <div class="col row dvcFields">
        <div class="col lblStyle">
          <form-input fieldName="Max Download Retries">
          </form-input>
        </div>
        <div class="col">
            <div class="ui-inputgroup">
                <p-spinner size="5" step="1" [(ngModel)]="upcParameters.maxDownloadRetry" [min]="0" [max]="3"></p-spinner>
                <span class="ui-inputgroup-addon">0~3</span>
            </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Download Timeout">
              </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <p-spinner size="5" step="1" [(ngModel)]="upcParameters.downloadTimeout" [min]="5" [max]="30"></p-spinner>
                    <span class="ui-inputgroup-addon">5~30</span>
                    <span class="ui-inputgroup-addon">min</span>
                </div>
            </div>
        </div>      
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Download Protocol">
              </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="downloadOptions" [(ngModel)]="upcParameters.protocolDownload"
                  [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
              </div>
        </div>      
    </div>
    
    <div class="row align-items-center">
  
        <div class="col">
          <p-checkbox binary="true" label="Report Enable" [(ngModel)]="upcParameters.enableReport">
          </p-checkbox>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Update Interval">
              </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <p-spinner size="5" step="1" [(ngModel)]="upcParameters.updateInterval" [min]="0" [max]="8760"></p-spinner>
                    <span class="ui-inputgroup-addon">0~8760</span>
                    <span class="ui-inputgroup-addon">h</span>
                </div>
            </div>
        </div>      
    </div>
    <div class="row align-items-center">
        <div class="col lblStyle">
            <form-input fieldName="Download URL">
            </form-input>
        </div>
        <div class="col">
            <div class="ui-inputgroup">
              <input type="text" pInputText [(ngModel)]="upcParameters.downloadUrl" maxlength="100" class="txtbStyle" />
            </div>
          </div>
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Mode">
              </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="modeOptions" [(ngModel)]="upcParameters.mode"
                  [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
              </div>
        </div>      
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Extended Status Report">
              </form-input>
            </div>
            <div class="col">
                <p-dropdown [options]="reportOptions" [(ngModel)]="upcParameters.report"
                  [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
              </div>
        </div>      
    </div>
    <div class="row align-items-center">
        <div class="col lblStyle">
            <form-input fieldName="Identifier Number">
            </form-input>
        </div>
        <div class="col">
            <div class="ui-inputgroup">
              <input type="text" pInputText [(ngModel)]="upcParameters.identifierNumber" maxlength="8" class="txtbStyle" />
            </div>
          </div>
    </div>
    <div class="row align-items-center">
        <form-input fieldName="Update Status Mask"></form-input>
        <div class="row align-items-center">
            <div class="col">
                <p-checkbox binary="true" label="Ignition Off" [(ngModel)]="upcParameters.ignitionOff">
                </p-checkbox>
              </div>
        </div>
        <div class="row align-items-center">
            <div class="col">
                <p-checkbox binary="true" label="Ignition On" [(ngModel)]="upcParameters.ignitionOn">
                </p-checkbox>
              </div>
        </div>

    </div>
    

  </p-accordionTab>